import { useEffect, useState } from 'react';
import DocumentService from '../../services/DocumentService';

const useFetchDocuments = (type, documentName, setDocuments, fetchContent) => {
  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const docs = await DocumentService.getDocuments(type);
        setDocuments(docs);
        if (documentName) {
          fetchContent(documentName);
        } else if (docs.length > 0) {
          const firstDocument = docs[0];
          fetchContent(firstDocument.fileName);
        }
      } catch (error) {
        console.error('Failed to fetch documents');
      }
    };

    fetchDocuments();
  }, [documentName, setDocuments, fetchContent]);
};

export default useFetchDocuments;
